import React, { useContext } from "react";

import Dashboard from "../pages/Dashboard";
import NewDashboard from "../layout-new/pages/Dashboard";
import { LayoutPreferenceContext } from "../context/LayoutPreference/LayoutPreferenceContext";

// Mesma ideia do TicketsPageSwitcher, pra rota "/" - projeto
// 2026-10-21 (ver PROMPT.md em D:\voicechat\novo layout, tarefa #62).
const DashboardPageSwitcher = () => {
	const { layout } = useContext(LayoutPreferenceContext);
	return layout === "new" ? <NewDashboard /> : <Dashboard />;
};

export default DashboardPageSwitcher;
